import { render } from "./PaymentsDistributors.vue?vue&type=template&id=8bf8b766&scoped=true"
import script from "./PaymentsDistributors.vue?vue&type=script&lang=js"
export * from "./PaymentsDistributors.vue?vue&type=script&lang=js"

import "./PaymentsDistributors.vue?vue&type=style&index=0&id=8bf8b766&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bf8b766"]])

export default __exports__